import { PROGRESSION_LEVELS } from '../../utils/progressionConstants';

export const PROGRESSION_SKILLS = [
  {
    skillId: 'ski_beginner_balanced_stance',
    sport: 'skiing',
    trackId: 'ski_progression_core',
    level: 'beginner',
    order: 1,
    name: 'Balanced Stance Basics',
    description: 'Build a centered stance and simple balance over both skis.',
    category: 'balance',
    prerequisites: [],
    nextSkillIds: ['ski_lower_intermediate_turn_initiation'],
    tags: ['balance', 'stance'],
    active: true,
  },
  {
    skillId: 'ski_lower_intermediate_turn_initiation',
    sport: 'skiing',
    trackId: 'ski_progression_core',
    level: 'lower_intermediate',
    order: 2,
    name: 'Turn Initiation Timing',
    description: 'Learn to release and guide the skis smoothly into the new turn.',
    category: 'timing_coordination',
    prerequisites: ['ski_beginner_balanced_stance'],
    nextSkillIds: ['ski_intermediate_turn_shape_control', 'ski_lower_intermediate_edge_release'],
    tags: ['turn initiation', 'release'],
    active: true,
  },
  {
    skillId: 'ski_lower_intermediate_edge_release',
    sport: 'skiing',
    trackId: 'ski_progression_core',
    level: 'lower_intermediate',
    order: 3,
    name: 'Edge Release Control',
    description: 'Develop cleaner release and re-engagement of the ski edges.',
    category: 'edging',
    prerequisites: ['ski_beginner_balanced_stance'],
    nextSkillIds: ['ski_intermediate_edge_engagement'],
    tags: ['edging', 'release'],
    active: true,
  },
  {
    skillId: 'ski_intermediate_turn_shape_control',
    sport: 'skiing',
    trackId: 'ski_progression_core',
    level: 'intermediate',
    order: 4,
    name: 'Turn Shape Control',
    description: 'Create more consistent turn size and shape on groomed terrain.',
    category: 'timing_coordination',
    prerequisites: ['ski_lower_intermediate_turn_initiation'],
    nextSkillIds: ['ski_intermediate_edge_engagement', 'ski_intermediate_pressure_control'],
    tags: ['turn shape', 'control'],
    active: true,
  },
  {
    skillId: 'ski_intermediate_edge_engagement',
    sport: 'skiing',
    trackId: 'ski_progression_core',
    level: 'intermediate',
    order: 5,
    name: 'Edge Engagement Control',
    description: 'Build earlier grip and cleaner platform through the shaping phase.',
    category: 'edging',
    prerequisites: ['ski_lower_intermediate_edge_release'],
    nextSkillIds: ['ski_upper_intermediate_edge_engagement', 'ski_carving_edge_angles'],
    tags: ['edge engagement', 'grip'],
    active: true,
  },
  {
    skillId: 'ski_intermediate_pressure_control',
    sport: 'skiing',
    trackId: 'ski_progression_core',
    level: 'intermediate',
    order: 6,
    name: 'Pressure Control Basics',
    description: 'Build clearer pressure transfer to the outside ski through the arc.',
    category: 'pressure',
    prerequisites: ['ski_intermediate_turn_shape_control'],
    nextSkillIds: ['ski_all_mountain_upper_lower_separation', 'ski_upper_intermediate_pressure_management'],
    tags: ['pressure', 'outside ski'],
    active: true,
  },
  {
    skillId: 'ski_upper_intermediate_edge_engagement',
    sport: 'skiing',
    trackId: 'ski_progression_core',
    level: 'upper_intermediate',
    order: 7,
    name: 'Early Edge Engagement',
    description: 'Refine edge timing earlier in the turn for stronger shaping and grip.',
    category: 'edging',
    prerequisites: ['ski_intermediate_edge_engagement'],
    nextSkillIds: ['ski_advanced_terrain_adaptation', 'ski_carving_edge_angles'],
    tags: ['edging', 'timing'],
    active: true,
  },
  {
    skillId: 'ski_upper_intermediate_pressure_management',
    sport: 'skiing',
    trackId: 'ski_progression_core',
    level: 'upper_intermediate',
    order: 8,
    name: 'Pressure Management Through the Arc',
    description: 'Manage pressure build and release with more flow and control.',
    category: 'pressure',
    prerequisites: ['ski_intermediate_pressure_control'],
    nextSkillIds: ['ski_advanced_terrain_adaptation', 'ski_freeride_variable_snow'],
    tags: ['pressure', 'flow'],
    active: true,
  },
  {
    skillId: 'ski_advanced_terrain_adaptation',
    sport: 'skiing',
    trackId: 'ski_progression_core',
    level: 'advanced',
    order: 9,
    name: 'Terrain Adaptation',
    description: 'Adjust turn tactics and stance for more variable terrain and steeper lines.',
    category: 'freeride_terrain',
    prerequisites: ['ski_upper_intermediate_pressure_management'],
    nextSkillIds: ['ski_advanced_short_turn_tactics', 'ski_freeride_line_choice'],
    tags: ['terrain', 'adaptability'],
    active: true,
  },
  {
    skillId: 'ski_advanced_short_turn_tactics',
    sport: 'skiing',
    trackId: 'ski_progression_core',
    level: 'advanced',
    order: 10,
    name: 'Short Turn Tactics',
    description: 'Apply tighter turn tactics for steeper or more tactical lines.',
    category: 'timing_coordination',
    prerequisites: ['ski_advanced_terrain_adaptation'],
    nextSkillIds: [],
    tags: ['short turns', 'tactics'],
    active: true,
  },
  {
    skillId: 'ski_all_mountain_balanced_stance',
    sport: 'skiing',
    trackId: 'ski_all_mountain_fundamentals',
    level: 'intermediate',
    order: 1,
    name: 'Balanced Stance Basics',
    description: 'Rebuild strong all-mountain stance habits for varied terrain and speed.',
    category: 'balance',
    prerequisites: ['ski_intermediate_turn_shape_control'],
    nextSkillIds: ['ski_all_mountain_upper_lower_separation'],
    tags: ['balance', 'all mountain'],
    active: true,
  },
  {
    skillId: 'ski_all_mountain_upper_lower_separation',
    sport: 'skiing',
    trackId: 'ski_all_mountain_fundamentals',
    level: 'upper_intermediate',
    order: 2,
    name: 'Upper-Lower Body Separation',
    description: 'Keep the torso quieter while the legs keep steering and shaping the skis.',
    category: 'rotation',
    prerequisites: ['ski_all_mountain_balanced_stance'],
    nextSkillIds: ['ski_all_mountain_pressure_management'],
    tags: ['rotation', 'quiet upper body'],
    active: true,
  },
  {
    skillId: 'ski_all_mountain_pressure_management',
    sport: 'skiing',
    trackId: 'ski_all_mountain_fundamentals',
    level: 'advanced',
    order: 3,
    name: 'Pressure Management Through the Arc',
    description: 'Blend stance, pressure, and ski-snow interaction for stronger all-mountain control.',
    category: 'pressure',
    prerequisites: ['ski_all_mountain_upper_lower_separation'],
    nextSkillIds: [],
    tags: ['pressure', 'all mountain'],
    active: true,
  },
  {
    skillId: 'ski_carving_edge_angles',
    sport: 'skiing',
    trackId: 'ski_carving_branch',
    level: 'intermediate',
    order: 1,
    name: 'Intro to Carving',
    description: 'Start building clean arcs from stronger edge commitment and shaping.',
    category: 'edging',
    prerequisites: ['ski_intermediate_edge_engagement'],
    nextSkillIds: ['ski_carving_clean_arc'],
    tags: ['carving', 'edging'],
    active: true,
  },
  {
    skillId: 'ski_carving_clean_arc',
    sport: 'skiing',
    trackId: 'ski_carving_branch',
    level: 'upper_intermediate',
    order: 2,
    name: 'Clean Arc Development',
    description: 'Link smoother carved arcs with better pressure build and release.',
    category: 'timing_coordination',
    prerequisites: ['ski_carving_edge_angles'],
    nextSkillIds: ['ski_carving_dynamic_shaping'],
    tags: ['carving', 'arc'],
    active: true,
  },
  {
    skillId: 'ski_carving_dynamic_shaping',
    sport: 'skiing',
    trackId: 'ski_carving_branch',
    level: 'advanced',
    order: 3,
    name: 'Dynamic Carving Shaping',
    description: 'Refine higher edge angles and stronger line control at speed.',
    category: 'edging',
    prerequisites: ['ski_carving_clean_arc'],
    nextSkillIds: [],
    tags: ['carving', 'dynamic'],
    active: true,
  },
  {
    skillId: 'ski_freeride_variable_snow',
    sport: 'skiing',
    trackId: 'ski_freeride_powder_branch',
    level: 'intermediate',
    order: 1,
    name: 'Variable Snow Basics',
    description: 'Adjust stance and line choice for chopped snow and changing surfaces.',
    category: 'freeride_terrain',
    prerequisites: ['ski_advanced_terrain_adaptation'],
    nextSkillIds: ['ski_freeride_line_choice'],
    tags: ['freeride', 'terrain'],
    active: true,
  },
  {
    skillId: 'ski_freeride_line_choice',
    sport: 'skiing',
    trackId: 'ski_freeride_powder_branch',
    level: 'upper_intermediate',
    order: 2,
    name: 'Line Choice and Speed Control',
    description: 'Choose cleaner lines and manage speed in freeride terrain.',
    category: 'freeride_terrain',
    prerequisites: ['ski_freeride_variable_snow'],
    nextSkillIds: ['ski_freeride_powder_flow'],
    tags: ['freeride', 'line choice'],
    active: true,
  },
  {
    skillId: 'ski_freeride_powder_flow',
    sport: 'skiing',
    trackId: 'ski_freeride_powder_branch',
    level: 'advanced',
    order: 3,
    name: 'Powder Flow and Adaptation',
    description: 'Blend rhythm, pressure, and terrain reading for smoother powder skiing.',
    category: 'freeride_terrain',
    prerequisites: ['ski_freeride_line_choice'],
    nextSkillIds: [],
    tags: ['powder', 'freeride'],
    active: true,
  },
  {
    skillId: 'snowboard_beginner_centered_stance',
    sport: 'snowboarding',
    trackId: 'snowboard_progression_core',
    level: 'beginner',
    order: 1,
    name: 'Centered Stance Basics',
    description: 'Build a more centered, mobile stance over the board.',
    category: 'balance',
    prerequisites: [],
    nextSkillIds: ['snowboard_lower_intermediate_edge_change'],
    tags: ['centered stance', 'balance'],
    active: true,
  },
  {
    skillId: 'snowboard_lower_intermediate_edge_change',
    sport: 'snowboarding',
    trackId: 'snowboard_progression_core',
    level: 'lower_intermediate',
    order: 2,
    name: 'Edge Change Timing',
    description: 'Create calmer transitions and cleaner edge change timing.',
    category: 'timing_coordination',
    prerequisites: ['snowboard_beginner_centered_stance'],
    nextSkillIds: ['snowboard_intermediate_turn_shape'],
    tags: ['edge change', 'transition timing'],
    active: true,
  },
  {
    skillId: 'snowboard_intermediate_turn_shape',
    sport: 'snowboarding',
    trackId: 'snowboard_progression_core',
    level: 'intermediate',
    order: 3,
    name: 'Turn Shape and Flow',
    description: 'Build rounder turns, calmer board flow, and more consistent track.',
    category: 'timing_coordination',
    prerequisites: ['snowboard_lower_intermediate_edge_change'],
    nextSkillIds: ['snowboard_intermediate_edge_commitment', 'snowboard_upper_intermediate_lower_body_steering'],
    tags: ['turn shape', 'flow'],
    active: true,
  },
  {
    skillId: 'snowboard_intermediate_edge_commitment',
    sport: 'snowboarding',
    trackId: 'snowboard_progression_core',
    level: 'intermediate',
    order: 4,
    name: 'Edge Commitment Basics',
    description: 'Improve grip and confidence through stronger early edge commitment.',
    category: 'edging',
    prerequisites: ['snowboard_intermediate_turn_shape'],
    nextSkillIds: ['snowboard_carving_edge_commitment'],
    tags: ['edge commitment', 'carving foundation'],
    active: true,
  },
  {
    skillId: 'snowboard_upper_intermediate_lower_body_steering',
    sport: 'snowboarding',
    trackId: 'snowboard_progression_core',
    level: 'upper_intermediate',
    order: 5,
    name: 'Lower-Body Steering',
    description: 'Guide the board more with the lower body while the upper body stays quieter.',
    category: 'rotation',
    prerequisites: ['snowboard_intermediate_turn_shape'],
    nextSkillIds: ['snowboard_advanced_terrain_adaptation'],
    tags: ['lower-body steering', 'quieter upper body'],
    active: true,
  },
  {
    skillId: 'snowboard_advanced_terrain_adaptation',
    sport: 'snowboarding',
    trackId: 'snowboard_progression_core',
    level: 'advanced',
    order: 6,
    name: 'Terrain Adaptation Confidence',
    description: 'Carry cleaner movement patterns into steeper or more variable terrain.',
    category: 'freeride_terrain',
    prerequisites: ['snowboard_upper_intermediate_lower_body_steering'],
    nextSkillIds: [],
    tags: ['terrain adaptation', 'confidence'],
    active: true,
  },
  {
    skillId: 'snowboard_all_mountain_centered_stance',
    sport: 'snowboarding',
    trackId: 'snowboard_all_mountain_fundamentals',
    level: 'intermediate',
    order: 1,
    name: 'Centered Stance Basics',
    description: 'Refine centered stance habits for more demanding all-mountain terrain.',
    category: 'balance',
    prerequisites: ['snowboard_intermediate_turn_shape'],
    nextSkillIds: ['snowboard_all_mountain_lower_body_steering'],
    tags: ['all mountain', 'centered stance'],
    active: true,
  },
  {
    skillId: 'snowboard_all_mountain_lower_body_steering',
    sport: 'snowboarding',
    trackId: 'snowboard_all_mountain_fundamentals',
    level: 'upper_intermediate',
    order: 2,
    name: 'Lower-Body Steering',
    description: 'Develop stronger separation and steering accuracy for all-mountain turns.',
    category: 'rotation',
    prerequisites: ['snowboard_all_mountain_centered_stance'],
    nextSkillIds: ['snowboard_all_mountain_turn_shape'],
    tags: ['all mountain', 'lower-body steering'],
    active: true,
  },
  {
    skillId: 'snowboard_all_mountain_turn_shape',
    sport: 'snowboarding',
    trackId: 'snowboard_all_mountain_fundamentals',
    level: 'advanced',
    order: 3,
    name: 'Turn Shape and Flow',
    description: 'Link stronger board flow and shape across more varied all-mountain laps.',
    category: 'pressure',
    prerequisites: ['snowboard_all_mountain_lower_body_steering'],
    nextSkillIds: [],
    tags: ['all mountain', 'flow'],
    active: true,
  },
  {
    skillId: 'snowboard_carving_edge_commitment',
    sport: 'snowboarding',
    trackId: 'snowboard_carving_branch',
    level: 'intermediate',
    order: 1,
    name: 'Edge Commitment for Carving',
    description: 'Start building cleaner carved lines from stronger edge confidence.',
    category: 'edging',
    prerequisites: ['snowboard_intermediate_edge_commitment'],
    nextSkillIds: ['snowboard_carving_clean_arc'],
    tags: ['carving', 'edge commitment'],
    active: true,
  },
  {
    skillId: 'snowboard_carving_clean_arc',
    sport: 'snowboarding',
    trackId: 'snowboard_carving_branch',
    level: 'upper_intermediate',
    order: 2,
    name: 'Clean Arc Carving',
    description: 'Refine cleaner heel-side and toe-side arcs with better board performance.',
    category: 'timing_coordination',
    prerequisites: ['snowboard_carving_edge_commitment'],
    nextSkillIds: ['snowboard_carving_dynamic_arc'],
    tags: ['carving', 'arc'],
    active: true,
  },
  {
    skillId: 'snowboard_carving_dynamic_arc',
    sport: 'snowboarding',
    trackId: 'snowboard_carving_branch',
    level: 'advanced',
    order: 3,
    name: 'Dynamic Carve Management',
    description: 'Blend edge angle, timing, and line shape into stronger dynamic carves.',
    category: 'edging',
    prerequisites: ['snowboard_carving_clean_arc'],
    nextSkillIds: [],
    tags: ['carving', 'dynamic'],
    active: true,
  },
  {
    skillId: 'snowboard_freestyle_flatground_180',
    sport: 'snowboarding',
    trackId: 'snowboard_freestyle_park_branch',
    level: 'intermediate',
    order: 1,
    name: 'Flatground 180 Foundations',
    description: 'Build the stance, timing, and confidence for first rotational freestyle skills.',
    category: 'freestyle',
    prerequisites: ['snowboard_intermediate_turn_shape'],
    nextSkillIds: ['snowboard_freestyle_side_hit_confidence'],
    tags: ['freestyle', '180'],
    active: true,
  },
  {
    skillId: 'snowboard_freestyle_side_hit_confidence',
    sport: 'snowboarding',
    trackId: 'snowboard_freestyle_park_branch',
    level: 'upper_intermediate',
    order: 2,
    name: 'Side Hit Confidence',
    description: 'Apply freestyle timing and control to natural terrain takeoffs and landings.',
    category: 'freestyle',
    prerequisites: ['snowboard_freestyle_flatground_180'],
    nextSkillIds: ['snowboard_freestyle_park_line_basics'],
    tags: ['freestyle', 'side hits'],
    active: true,
  },
  {
    skillId: 'snowboard_freestyle_park_line_basics',
    sport: 'snowboarding',
    trackId: 'snowboard_freestyle_park_branch',
    level: 'advanced',
    order: 3,
    name: 'Park Line Basics',
    description: 'String together basic features with more flow, confidence, and consistency.',
    category: 'freestyle',
    prerequisites: ['snowboard_freestyle_side_hit_confidence'],
    nextSkillIds: [],
    tags: ['freestyle', 'park'],
    active: true,
  },
];

function levelIndex(level) {
  return PROGRESSION_LEVELS.indexOf(level);
}

export function getProgressionSkillsForSport(sport) {
  return PROGRESSION_SKILLS
    .filter((skill) => skill.sport === sport && skill.active)
    .sort((a, b) => {
      const trackCompare = a.trackId.localeCompare(b.trackId);
      if (trackCompare !== 0) return trackCompare;
      const levelCompare = levelIndex(a.level) - levelIndex(b.level);
      if (levelCompare !== 0) return levelCompare;
      return (a.order || 0) - (b.order || 0) || a.name.localeCompare(b.name);
    });
}

export function getProgressionSkillById(skillId) {
  return PROGRESSION_SKILLS.find((skill) => skill.skillId === skillId) || null;
}
